// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6Gooq","left":"styles_left__yQZX6"};